<template>
  <button
    class="button-toggle"
    :data-off="!userPreferences.isActiveMyLanguageOnly"
    @click="onClickTggleLanguage"
  >
    <ToggleSwitch
      :modelValue="userPreferences.isActiveMyLanguageOnly"
      @update:modelValue="onClickTggleLanguage"
    />
    {{ t('my_language') }}
  </button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { storeToRefs } from 'pinia';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();
const { userPreferences } = storeToRefs(userStore);

const { t } = useI18n();

// 버튼/토글 클릭 시
const onClickTggleLanguage = () => {
  userPreferences.value.isActiveMyLanguageOnly =
    !userPreferences.value.isActiveMyLanguageOnly;
  userPreferences.value.screenScrollHeight = userPreferences.value
    .isActiveMyLanguageOnly
    ? 50
    : 60;
};
</script>

<style scoped lang="scss"></style>
